export default __webpack_public_path__ + "static/media/snd_00034.ba76a1ff.mp4";